export const galleries = [
  {
    id: 'club-interiors',
    name: 'Club Interiors',
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: 'Explore the elegant architecture and historic rooms of Andhra Social & Cultural Association.',
    images: [
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
      'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
      'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
  },
  {
    id: 'summer-gala-2025',
    name: 'Summer Gala 2025',
    image:
      'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: 'Highlights from our spectacular annual summer celebration on the terrace.',
    images: [
      'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
      'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    ],
  },
  {
    id: 'golf-championship',
    name: 'Annual Golf Championship',
    image:
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: "Action shots and prize giving from this year's member tournament.",
    images: [
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1535136104956-617ea4c68b94?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
  },
  {
    id: 'culinary-creations',
    name: 'Culinary Creations',
    image:
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: 'A showcase of the exquisite dishes prepared by our Executive Chef.',
    images: [
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1572116469696-31de0f17ce34?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
  },
]

export const getGalleryBySlug = (slug: string) =>
  galleries.find((g) => g.id === slug)
